// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-support-period.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-support-period',
  title:
    'Declare, honour and publish the support period and end-of-life notice for products with digital elements',
  description:
    'For each product with digital elements (PDE) that is in scope, the manufacturer must determine and declare the support period (at least five years unless the expected lifecycle is shorter — CRA Art. 13(8)), keep the support period end date current, and ensure security updates and vulnerability handling continue throughout. The support period must be available to users (Annex II §5). After end of support, the manufacturer informs users in advance (Art. 13(19)).',
  category: 'compliance',
  scfIds: ['SCF-MSS-004', 'SCF-GOV-011'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'per-product',
  perProductCriteria: [
    {
      type: 'product-support-period-valid',
      description: 'Support period end date set and not expired',
    },
  ],
  domainActions: [],
};
